// src/api/sede.js
import { apiFetch } from './index.js';

export const obtenerSedesActivas = async () => {
  try {
    const response = await apiFetch('/Sede/activas');
    const data = Array.isArray(response) ? response : (response.data || []);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerSedes = async () => {
  try {
    const response = await apiFetch('/Sede');
    const data = Array.isArray(response) ? response : (response.data || []);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const crearSede = async (sedeData) => {
  try {
    const response = await apiFetch('/Sede', {
      method: 'POST',
      body: sedeData
    });
    return { success: true, data: response, message: 'Sede creada' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const actualizarSede = async (id, sedeData) => {
  try {
    const response = await apiFetch(`/Sede/${id}`, {
      method: 'PUT',
      body: { ...sedeData, idSede: id }
    });
    return { success: true, data: response, message: 'Sede actualizada' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const eliminarSede = async (id) => {
  try {
    await apiFetch(`/Sede/${id}`, { method: 'DELETE' });
    return { success: true, message: 'Sede eliminada/desactivada' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const cambiarEstadoSede = async (idSede, nuevoEstado, idUsuario) => {
  try {
    const response = await apiFetch(`/Sede/cambiar-estado`, {
      method: 'PATCH',
      body: { idSede, nuevoEstado, idUsuario }
    });
    return { success: true, data: response, message: 'Estado actualizado' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
